import { Asset, AssetType } from './Asset';
import { AssetObject } from './AssetObject';
import { EnemyConfig } from './EnemyGenerator';

export interface EnemyPrefabConfig {
  probabilityMin: number;
  probabilityMid: number;
  probabilityMax: number;
  minPoint: number;
  pathWidth: number;
  spawnRange: number;
  despawnRange: number;
}

export class EnemyPrefabs {
  static create(config: EnemyPrefabConfig): EnemyConfig {
    const enemyConfig: EnemyConfig = {
      assets: [
        new Asset('enemy-male-a', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-a.glb').withMeshIndex(0),
        new Asset('enemy-male-b', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-b.glb').withMeshIndex(0),
        new Asset('enemy-male-c', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-c.glb').withMeshIndex(0),
        new Asset('enemy-male-d', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-d.glb').withMeshIndex(0),
        new Asset('enemy-male-e', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-e.glb').withMeshIndex(0),
        new Asset('enemy-male-f', AssetType.MESH, 'assets/model/mini_characters/', 'character-male-f.glb').withMeshIndex(0),
        new Asset('enemy-female-a', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-a.glb').withMeshIndex(0),
        new Asset('enemy-female-b', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-b.glb').withMeshIndex(0),
        new Asset('enemy-female-c', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-c.glb').withMeshIndex(0),
        new Asset('enemy-female-d', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-d.glb').withMeshIndex(0),
        new Asset('enemy-female-e', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-e.glb').withMeshIndex(0),
        new Asset('enemy-female-f', AssetType.MESH, 'assets/model/mini_characters/', 'character-female-f.glb').withMeshIndex(0),
      ],
      assetObjects: [
        AssetObject.fromAsset('enemy-male-a', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-male-b', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-male-c', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-male-d', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-male-e', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-male-f', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-female-a', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-female-b', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-female-c', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-female-d', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-female-e', 2).withType('enemy'),
        AssetObject.fromAsset('enemy-female-f', 2).withType('enemy'),
      ],
      distributions: [
        {
          types: ['enemy'],
          behavior: 'mimic',
          probability: config.probabilityMin,
          detectionRange: 15,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'chargeJump',
          probability: config.probabilityMin,
          detectionRange: 25,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'teleport',
          probability: config.probabilityMin,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'snipe',
          probability: config.probabilityMin,
          offsetRange: { min: -4, max: 4 },
          speed: 10,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'patrol',
          probability: config.probabilityMin,
          offsetRange: { min: -1, max: 1 },
          patrolWidth: 6,
          speed: 2,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'circle',
          probability: config.probabilityMin,
          offsetRange: { min: -1, max: 1 },
          circleRadius: 2,
          speed: 3,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'attack',
          detectionRange: 12,
          attackRange: 2,
          offsetRange: { min: -4, max: 4 },
          probability: config.probabilityMin,
          speed: 4,
          minPoint: config.minPoint,
        },
        {
          types: ['enemy'],
          behavior: 'idle',
          probability: config.probabilityMin,
          offsetRange: { min: -4, max: 4 },
          minPoint: config.minPoint,
        },

        {
          types: ['enemy'],
          behavior: 'floatingBomber',
          floatHeight: 4,
          floatRadius: 3,
          bombInterval: 2.5,
          probability: config.probabilityMin,
          offsetRange: { min: -1, max: 1 },
          minPoint: config.minPoint,
        },
      ],
      spawnRange: config.spawnRange,
      despawnRange: config.despawnRange,
    };

    return enemyConfig;
  }
}
